import {post} from 'aws-amplify/api';
import {Command, type PostMethod} from '../../Command';

/**
 * Premier contact (first touch) avec l'app, capturé par le client et transmis à l'inscription.
 * Le serveur le nettoie et en déduit le canal d'acquisition (`users.acquisition`).
 */
export interface SignUpAcquisitionInput {
  source?: string;
  medium?: string;
  campaign?: string;
  content?: string;
  referrer?: string;
  landingPage?: string;
  /** ISO 8601. */
  capturedAt?: string;
}

export interface SignUpUserInput {
  email: string;
  locale: 'de' | 'en' | 'es' | 'fr' | 'it' | 'pt';
  marketingChecked: boolean;
  invitationId?: string;
  acquisition?: SignUpAcquisitionInput;
}

export class SignUpUserCommand extends Command<PostMethod> {
  constructor({email, locale, marketingChecked, invitationId, acquisition}: SignUpUserInput) {
    super(post, {
      path: '/signup',
      options: {
        body: {
          email,
          locale,
          marketingChecked,
          ...(invitationId !== undefined ? {invitationId} : {}),
          ...(acquisition !== undefined ? {acquisition: {...acquisition}} : {}),
        },
      },
    });
  }

  async deserialize(output: ReturnType<typeof post>): Promise<void> {
    await output.response;
  }
}
